import { mirrorX, strokeWidth } from "apparatus/draw";
import { Interpolator, Segments } from "apparatus/library/common";
import { Caps } from "apparatus/library/shared/cap";
import { Group, Path } from "paper";
export class PlasticReagentBottle {
    constructor() {
        this.radiusInterpolator = new Interpolator([60, 180], [30, 60]);
    }
    render(appearance) {
        const radius = this.radiusInterpolator.interpolate(appearance.size);
        const height = appearance.size;
        const bottleBackPart = new Path(Segments([[radius, 0], [0, radius * -0.75]], [[radius, height]]));
        mirrorX(bottleBackPart);
        bottleBackPart.closePath();
        const outline = bottleBackPart.clone().withStroke(strokeWidth("default"), "#888888");
        bottleBackPart.setGradientFill("right", [["#dddddd", 0.0], ["#eeeeee", 0.15], ["#eeeeee", 0.85], ["#dddddd", 1.0]]);
        // const bottleFrontPart = new Path(Segments(
        //     [[radius, 10],[-20, radius * -0.5]],
        //     [[radius, height]],
        // ))
        // mirrorX(bottleFrontPart)
        // bottleFrontPart.closePath()
        // bottleFrontPart.setGradientFill("right", [["#dddddd", 0.0], ["#eeeeee", 0.15], ["#eeeeee", 0.85], ["#dddddd", 1.0]])
        const lightLine = new Path(Segments([[-radius, height - 20]], [[radius, height - 20]])).withStroke(2.0, "#f6f6f6");
        const darkLine = new Path(Segments([[-radius, 10 + height / 10]], [[radius, 10 + height / 10]])).withStroke(2.0, "#cccccc");
        const cap = Caps.createCap({ radius: radius - 10, appearance });
        cap.position.y -= 30 + height / 10;
        const graphic = new Group([bottleBackPart, darkLine, lightLine, outline, cap]);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            snapping: graphic.placeable(),
        };
    }
}
PlasticReagentBottle.properties = {
    label: "Plastic Reagent Bottle",
    defaultAppearance: Object.assign({ size: 100 }, Caps.defaultAppearance),
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 60, max: 180
        }
    ],
};
